var ProgressSpinnerComponent = /** @class */ (function () {
    function ProgressSpinnerComponent() {
        this.progressSpinnerColor = 'primary';
    }
    return ProgressSpinnerComponent;
}());
export { ProgressSpinnerComponent };
